export const UNIT_VARIATION_EXPECTED = 'unit_variation_expected';